/**
 * 全局请求 loading 状态
 * 在 axios 拦截器中自动增减 requestCount
 * GlobalLoading.vue 监听此计数显示/隐藏全局 loading 指示器
 */
export default {
  namespaced: true,
  state: {
    requestCount: 0, // 当前正在进行的请求数
    submitMode: false, // true=提交模式（v-click-lock 触发），false=查询模式（v-debounce-click 触发）
  },
  mutations: {
    INCREMENT(state) {
      state.requestCount++;
    },
    DECREMENT(state) {
      if (state.requestCount > 0) {
        state.requestCount--;
      }
    },
    RESET(state) {
      state.requestCount = 0;
    },
    SET_SUBMIT_MODE(state, val) {
      state.submitMode = val;
    },
  },
  getters: {
    isLoading(state) {
      return state.requestCount > 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/loading.js